import React, { useMemo, useEffect } from 'react';
import Presentations from './presentations/Presentations';
import styles from './QuizSidebar.module.scss';
import { Content, Quiz, QuizContent } from '@api/graphql-codegen';
import { useCourseContent } from '@hooks/useCourseContent';
import { useMediaQuery } from 'react-responsive';

interface SidebarUnitProps {
  quiz: Quiz;
  quizContent?: QuizContent
  isParentApp?: boolean;
  closeNav?: () => void;
}

const SidebarUnit = ({ quiz, quizContent, closeNav }: SidebarUnitProps) => {

  const { setContent, content } = useCourseContent();
  const isTablet = useMemo(() => {
    const userAgent = navigator.userAgent.toLowerCase();
    return /(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/.test(userAgent)
  }, []);
  const isMobile = useMediaQuery({ maxWidth: 1024 });

  const modules = useMemo(() => {
    return [...quizContent?.contents ?? []]
  }, [quizContent]);

  const listwrapper = useMemo(() => [styles.wrapper, styles.opened].join(' '), []);

  useEffect(() => {
    if (modules.length > 0 && !content) {
      setContent(modules.at(0) as any)  
    }
  }, [content, modules, setContent])

  return (
    <div className={listwrapper}>
      <section className={styles.list} style={{backgroundColor: (isTablet || isMobile) ? "#FFE4CF" : "#FFFFFF"}}>
        <Presentations
          lessonOpened={true}
          quiz={quiz}
          contents={modules as Content[]}
          closeNav={closeNav}
        />
      </section>
    </div>
  )
}

export default SidebarUnit;
